import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { PenguinIllustration } from "@/components/PenguinState";

// Client-side connectivity guard. Shows the Network Issue penguin ONLY when the device is
// genuinely offline (navigator.onLine / offline event) — never for API/server errors.
export default function NetworkStatus() {
  const [offline, setOffline] = useState(() => typeof navigator !== "undefined" && navigator.onLine === false);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      data-testid="network-issue-overlay"
      className="fixed inset-0 z-[9998] flex flex-col items-center justify-center bg-white/95 px-6 text-center backdrop-blur-sm"
    >
      <PenguinIllustration variant="network" size="page" testid="penguin-network" />
      <h1 className="font-display mt-6 text-2xl font-bold text-[#0B132B] sm:text-3xl">Network Issue</h1>
      <p className="mt-2 max-w-md text-sm text-slate-500">Please check your internet connection and try again.</p>
      <button
        onClick={() => { if (navigator.onLine) setOffline(false); }}
        data-testid="network-retry"
        className="mt-6 inline-flex items-center justify-center gap-2 rounded-full bg-[#14B8A6] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#0B132B]"
      >
        <RefreshCw size={16} /> Try Again
      </button>
    </div>
  );
}
